<div class="cm-skeleton-form">
  <!-- Form header -->
  <div class="cm-skeleton-form-header">
    <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 220px;"></div>
    <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 380px; margin-top: 0.25rem;"></div>
  </div>

  <!-- First row: Name and Category -->
  <div class="cm-skeleton-form-row">
    <div class="cm-skeleton-form-field">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 60px; margin-bottom: 0.5rem;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
    </div>
    <div class="cm-skeleton-form-field">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 80px; margin-bottom: 0.5rem;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
    </div>
  </div>

  <!-- Second row: Description and Active -->
  <div class="cm-skeleton-form-row">
    <div class="cm-skeleton-form-field cm-skeleton-form-field--large">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 120px; border-radius: 4px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 90%; margin-top: 0.5rem;"></div>
    </div>
    <div class="cm-skeleton-form-field">
      <div class="cm-skeleton-form-toggle">
        <div class="cm-skeleton cm-skeleton--circle cm-skeleton--{{ animation() }}" style="width: 44px; height: 24px; border-radius: 12px;"></div>
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 60px;"></div>
      </div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100%; margin-top: 0.5rem;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 80%; margin-top: 0.25rem;"></div>
    </div>
  </div>
</div>
